import { Projeto } from "../../types"
import { Box } from "@mui/material"
import { useCallback } from "react"
import { SelectTipoProposta } from "./containers/SelectTipoProposta"
import { InputValorServico } from "./containers/InputValorServico"
import { InputCustoAnualManutencao } from "./containers/InputCustoAnualManutencao"
import { JustificativaValorServico } from "./containers/InputJustificativaValorServico"
import { useObservable } from "src/framework/store/storeUtil"
import { revendas$ } from "src/store/global.store"

interface InputsSectionProps {
  formState: Projeto
  setFormState: (newState: Partial<Projeto>) => void
  servicoObrigatorio: boolean
  exibirJustificativaValorServico: boolean
  mostrarCampoValorServico: boolean
  valorMinimoServico?: number
}


function InputsSection({ formState, valorMinimoServico, setFormState, mostrarCampoValorServico, servicoObrigatorio, exibirJustificativaValorServico }: InputsSectionProps) {
  const revendasState = useObservable(revendas$);
  
  const renderDimensionado = useCallback(() => {
    if (formState.tipo !== 'dimensionado') return null;
    return (
      <>
        <Box className="row">
          <Box className={'L12'}>
            <SelectTipoProposta formState={formState} setFormState={setFormState} />
          </Box>
        </Box>
        <Box className="row">
          {mostrarCampoValorServico && formState.tipo_proposta?.value === 'gerador-com-instalacao' && (
            <Box className='L6'>
              <InputValorServico valorMinimoServico={valorMinimoServico} formState={formState} setFormState={setFormState} servicoObrigatorio={servicoObrigatorio} />
            </Box>
          )}
          <Box className={'L6'}>
            <InputCustoAnualManutencao formState={formState} setFormState={setFormState} />
          </Box>
        </Box>
        <Box className="row">
          {exibirJustificativaValorServico && (
            <Box className="X12 M12">
              <JustificativaValorServico formState={formState} setFormState={setFormState} />
            </Box>
          )}
        </Box>
      </>
    )
  }, [exibirJustificativaValorServico, formState, mostrarCampoValorServico, servicoObrigatorio, setFormState, valorMinimoServico])

  const renderPersonalizado = useCallback(() => {
    if (formState.tipo !== 'personalizado') return null;
    return (
      <>
        <Box className="row">
          <Box className={'L12'}>
            <SelectTipoProposta formState={formState} setFormState={setFormState} />
          </Box>
        </Box>
        <Box className="row">
          {mostrarCampoValorServico && 
            <Box className={'L6'}>
              <InputValorServico valorMinimoServico={valorMinimoServico} formState={formState} setFormState={setFormState} servicoObrigatorio={servicoObrigatorio} />
            </Box>
          }
        </Box>
        {exibirJustificativaValorServico && (
          <Box>
            <JustificativaValorServico formState={formState} setFormState={setFormState} />
          </Box>
        )}
      </>
    )
    
  }, [formState, setFormState, mostrarCampoValorServico, valorMinimoServico, servicoObrigatorio, exibirJustificativaValorServico])

  const renderKits = useCallback(() => {
    if (formState.tipo !== 'kit') return null;

    if (formState.revenda_id && !formState.revenda) {
      const idxRevenda = revendasState?.data.findIndex((d: any) => d.id === formState.revenda_id)
            
      if (idxRevenda > -1) {
        formState.revenda = revendasState.data[idxRevenda];
      }
    }

    return (
      <>
        <Box className={"row"}>
          {/*Desativado SOL-1576*/}
          {/*<Box className="L6">
            <InputTempoDeVida formState={formState}/>
          </Box>*/}
          <Box className="L12">
            <SelectTipoProposta formState={formState} setFormState={setFormState}/>
          </Box>
        </Box>
        
        <Box className={"row"}>
          {mostrarCampoValorServico &&
            <Box className='L12'>
              <InputValorServico valorMinimoServico={valorMinimoServico} formState={formState} setFormState={setFormState} servicoObrigatorio={servicoObrigatorio} />
            </Box>
          }
        </Box>
        {exibirJustificativaValorServico && (
          <Box>
            <JustificativaValorServico formState={formState} setFormState={setFormState} />
          </Box>
        )}
      </>
    )

  },[formState, setFormState, mostrarCampoValorServico, valorMinimoServico, servicoObrigatorio, exibirJustificativaValorServico])

  return (
    <>
      {renderKits()}
      {renderPersonalizado()}
      {renderDimensionado()}
    </>
  )
}

export { InputsSection }